import { Box, Button, Card, CardContent, Chip, Typography } from '@shared/ui';
import { toAppointmentCardModel } from './appointmentTransforms';
import type { AdminAppointment } from './types';

interface AppointmentCardProps {
  appointment: AdminAppointment;
}

export function AppointmentCard({ appointment }: AppointmentCardProps) {
  const model = toAppointmentCardModel(appointment);
  return (
    <Card data-testid={`appointment-card-${model.id}`}>
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography component="h2" variant="h6">
            {model.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {model.timeRange}
          </Typography>
          <Typography>{model.statusLabel}</Typography>
          <Typography variant="body2">{model.providerLabel}</Typography>
          {model.issueLabels.length > 0 && (
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {model.issueLabels.map((issue) => (
                <Chip key={issue} label={issue} color="warning" size="small" />
              ))}
            </Box>
          )}
          {model.attendeeLabels.map((attendee) => (
            <Typography key={attendee} variant="body2">
              {attendee}
            </Typography>
          ))}
          {appointment.action_capabilities.view_history.allowed && (
            <Button href={model.historyHref} size="small" variant="text">
              View history
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

export default AppointmentCard;
